export const poze = [
	{
		link:'https://static.pexels.com/photos/52500/horse-herd-fog-nature-52500.jpeg',
		desc:'Horse'
	},
	{
		link:'https://static.pexels.com/photos/66898/elephant-cub-tsavo-kenya-66898.jpeg',
		desc:'Elephant cub'
	},
	{
		link:'https://static.pexels.com/photos/213399/pexels-photo-213399.jpeg',
		desc:'Fishes'
	},
	{
		link:'https://static.pexels.com/photos/158471/ibis-bird-red-animals-158471.jpeg',
		desc:'Ibis Bird'
	},
	{
		link:'https://static.pexels.com/photos/133459/pexels-photo-133459.jpeg',
		desc:'Lemuri'
	},
	{
			link:'https://static.pexels.com/photos/50988/ape-berber-monkeys-mammal-affchen-50988.jpeg',
			desc:'Monkey'
	}

];

export default poze;